import moment from 'jalali-moment';
import {durationUnits} from 'utilities/helper/durationUnitsOption';

export const initialValues = (farm: IFarmAddInfo | undefined) => {
  const datetime = moment(farm?.harvest_datetime, 'YYYY-MM-DD')
    .locale('fa')
    .format('YYYY/MM/DD');
  return {
    price: '',
    duration: '',
    duration_unit: durationUnits[0].value?.toString(),
    area: farm?.area,
    harvest_datetime: datetime,
    financial_type: 'cash',
  };
};
